<template>
  <v-container class="col-12">
    <v-card class="pa-4 mt-4">
      <v-data-table
        :headers="headers"
        :items="duplicates.items || []"
        :loading="duplicates.loading"
        sort-by="created"
        sort-desc
        :footer-props="{'items-per-page-options': [50, 100, 200]}"
        :options.sync="duplicates.tableOptions"
        :server-items-length="duplicates.totalItems"
        :items-per-page="100"
        style="z-index: 0; position: relative; white-space: nowrap"
      >
        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + (item.account.prefix || '') + (item.account.login.replace(new RegExp('^' + (item.account.prefix || '')), ''))" target="_blank">
            {{ (item.account.prefix || '') + (item.account.login.replace(new RegExp('^' + (item.account.prefix || '')), '')) }}
          </a>
        </template>
        <template v-slot:item.double="{ item, header }">
          <a :href="'/user-management/' + (item.double.prefix || '') + (item.double.login.replace(new RegExp('^' + (item.double.prefix || '')), ''))" target="_blank">
            {{ (item.double.prefix || '') + (item.double.login.replace(new RegExp('^' + (item.double.prefix || '')), '')) }}
          </a>
        </template>

        <template v-slot:item.data.ip="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
            style="display: inline-block;"
          ></v-checkbox>
          <span style="vertical-align: super">{{ item.ip.replace(',', ' ') }}</span>
        </template>
        <template v-slot:item.data.email="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.data.login="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.data.profile="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.data.password="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
            style="display: inline-block;"
          ></v-checkbox>
          <span style="vertical-align: super">{{ item.password }}</span>
        </template>
        <template v-slot:item.data.fingerprint="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.data.withdraw_account="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.data.deviceid="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>
        <template v-slot:item.data.withdraw_account="{ item, value }">
          <v-checkbox
            v-model="value"
            hide-details
            readonly
            class="mt-0 pt-0"
          ></v-checkbox>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>

<style>
</style>

<script>

  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import { isEqual } from 'lodash'

  export default {

    props: [],
    data: () => ({
      tableOptionAID: null,
      headers: [
        { text: 'Login', value: 'login' },
        { text: 'Duplicate', value: 'double' },
        { text: 'IP', value: 'data.ip', sortable: false, },
        { text: 'Email', value: 'data.email', sortable: false },
        { text: 'Login', value: 'data.login', sortable: false },
        { text: 'Profile', value: 'data.profile', sortable: false },
        { text: 'Password', value: 'data.password', sortable: false },
        { text: 'Fingerprint', value: 'data.fingerprint', sortable: false },
        { text: 'Email', value: 'data.email', sortable: false },
        { text: 'Device', value: 'data.deviceid', sortable: false },
        { text: 'Paysystem', value: 'data.withdraw_account', sortable: false },
      ],
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', duplicates: 'account/duplicates' })
    },

    watch: {
      'duplicates.tableOptions': function (newValue, oldValue) {
        if (this.tableOptionAID == this.activeAccount.account_id && !isEqual(newValue, oldValue)) {
          this.$store.dispatch('account/loadDuplicates', { account: this.activeAccount.account }).catch(e => {
            this.$notification.show = true
            this.$notification.message = e.response.data.message
            this.$notification.type = 'error'
          })
        }
        this.tableOptionAID = 1 && this.activeAccount.account_id
      }
    },

    methods: {},
  }
</script>
